import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Card, CardContent, CircularProgress, Alert, List, ListItem, ListItemText } from '@mui/material';
import useDataFetch, { usePostDataFetch } from '../../utils/useDataFetch';

const Carpool = ({ terminId }) => {
    const { data, error, isLoading, refetch } = useDataFetch({ url: `/carpools/termin/${terminId}` });
    const { postData: createCarpool, isLoading: isCreating } = usePostDataFetch();
    const { postData: joinCarpool, isLoading: isJoining } = usePostDataFetch();

    const [offerForm, setOfferForm] = useState(false);
    const [formData, setFormData] = useState({ plaetze_gesamt: 3, treffpunkt: '', treffzeit: '' });

    const handleCreate = async (e) => {
        e.preventDefault();
        await createCarpool({ url: '/carpools', aBody: { termin_id: terminId, ...formData }, skipAuth: false });
        setOfferForm(false);
        refetch();
    };

    const handleJoin = async (carpoolId) => {
        await joinCarpool({ url: `/carpools/join/${carpoolId}`, aBody: {}, skipAuth: false });
        refetch();
    };

    if (isLoading) return <CircularProgress />;
    if (error) return <Alert severity="error">{error}</Alert>;

    const carpools = data?.carpools || [];

    return (
        <Box sx={{ mt: 2, p: 2, bgcolor: 'background.default', borderRadius: "12px" }}>
            <Typography variant="subtitle2" gutterBottom>Fahrgemeinschaften</Typography>

            {carpools.length === 0 ? (
                <Typography variant="body2" color="text.secondary">Noch keine Fahrten angeboten.</Typography>
            ) : (
                <Box sx={{ mb: 2 }}>
                    {carpools.map(c => (
                        <Card key={c.id} variant="outlined" sx={{ mb: 1 }}>
                            <CardContent sx={{ pb: '16px !important' }}>
                                <Typography variant="body2">
                                    <b>Fahrer:</b> {c.first_name} {c.last_name}
                                </Typography>
                                <Typography variant="body2">
                                    <b>Freie Plätze:</b> {c.plaetze_frei} / {c.plaetze_gesamt}
                                </Typography>
                                {c.treffpunkt && <Typography variant="body2"><b>Treffpunkt:</b> {c.treffpunkt} um {c.treffzeit}</Typography>}

                                {c.mitfahrer && c.mitfahrer.length > 0 && (
                                    <Typography variant="caption" display="block" sx={{ mt: 1, color: 'text.secondary' }}>
                                        Mitfahrer: {c.mitfahrer.map(m => m.first_name).join(', ')}
                                    </Typography>
                                )}

                                {c.plaetze_frei > 0 && (
                                    <Button
                                        size="small"
                                        variant="contained"
                                        sx={{ mt: 1 }}
                                        onClick={() => handleJoin(c.id)}
                                        disabled={isJoining}
                                    >Mitfahren</Button>
                                )}
                            </CardContent>
                        </Card>
                    ))}
                </Box>
            )}

            {!offerForm ? (
                <Button size="small" onClick={() => setOfferForm(true)}>Fahrt anbieten</Button>
            ) : (
                <form onSubmit={handleCreate}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 1 }}>
                        <TextField
                            label="Anzahl Plätze"
                            type="number"
                            size="small"
                            InputProps={{ inputProps: { min: 1, max: 8 } }}
                            value={formData.plaetze_gesamt}
                            onChange={e => setFormData({ ...formData, plaetze_gesamt: e.target.value })}
                            required
                        />
                        <TextField
                            label="Treffpunkt"
                            size="small"
                            value={formData.treffpunkt}
                            onChange={e => setFormData({ ...formData, treffpunkt: e.target.value })}
                        />
                        <TextField
                            label="Treffzeit (z.B. 18:00)"
                            size="small"
                            value={formData.treffzeit}
                            onChange={e => setFormData({ ...formData, treffzeit: e.target.value })}
                        />
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <Button type="submit" variant="contained" size="small" disabled={isCreating}>Speichern</Button>
                            <Button size="small" onClick={() => setOfferForm(false)}>Abbrechen</Button>
                        </Box>
                    </Box>
                </form>
            )}
        </Box>
    );
};

export default Carpool;
